// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-no-translate]{translate:none;-webkit-user-select:none;-moz-user-select:none;user-select:none}.mzeuY{border-top:1px solid #cac5cf;margin-top:20px;padding-top:25px !important;word-wrap:break-word}.mzeuY p{color:var(--whitelabeling-primary-dark-color);font-size:18px;line-height:25px;margin-bottom:30px;margin-top:0}@media only screen and (max-width: 767px){.mzeuY p{font-size:16px}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sourcesContainer": "mzeuY"
};
module.exports = ___CSS_LOADER_EXPORT___;
